import demystifyingBusinessFinanceJargon from "../../assets/images/demystifying-business-finance-jargon-apra-bbsw-lvr-small.webp";
import transformyourretirementwithhomeequityreleasesmaller from "../../assets/images/transform-your-retirement-small.webp";
import comprehensiveLoanDocumentationChecklist from "../../assets/images/Comprehensive-Loan-Documentation-Checklist-small.webp";
import gettingtheBasisofAdviceRight from "../../assets/images/Getting-the-Basis-of-Advice-Right-small.webp";
import empoweringYourBusinessGrowth from "../../assets/images/Empowering-Your-Business-Growth-small.webp";
import exploringTheLenders from "../../assets/images/Exploring-The-Lenders-small.webp";
import assessingBorrowingCapacity from "../../assets/images/Assessing-Borrowing-Capacity-small.webp";
import navigatingUncertainTimes from "../../assets/images/Navigating-Uncertain-Times-small.webp";
import understandingRatiosinCommercialLending from "../../assets/images/Understanding-Ratios-in-Commercial-Lending-small.webp";
import debtPaymentinFull from "../../assets/images/Debt-Payment-in-Full-small.webp";
import exploringDifferentLoanTypes from "../../assets/images/Exploring-Different-Loan-Types-small.webp";
import understandingInterestRatesinCommercialFinance from "../../assets/images/Understanding-interest-Rates-in-Commercial-Finance-small.webp";
import masteringCommercialLending from "../../assets/images/Mastering-Commercial-Lending-small.webp";
import theImportanceofGuranteeandIndemnitties from "../../assets/images/The-Importance-of-Gurantee-and-Indemnitties-small.webp";
import unlockingBusinessGrowth from "../../assets/images/Unlocking-Business-Growth-small.webp";
import businessLoanReadinessAssessment from "../../assets/images/business-loan-readiness-assessment-small.webp";
import unlockingGrowth from "../../assets/images/Unlocking-Growth-small.webp";
import understandingPropertySecurity from "../../assets/images/uNDERSTANDING-pROPERTY-sECURITY-small.webp";
import businessLendingUnderstanding from "../../assets/images/business-lending-understanding-serviceability-and-covenant-ratios-small.webp";
import understandingLoanRepayment from "../../assets/images/understanding-loan-repayment-structures-and-interest-rates-in-business-lending-small.webp";
import guideToRatios from "../../assets/images/a-guide-to-ratios-and-financial-analysis-to-understanding-business-lending-security-types-small.webp";
import keyFactorsInLending from "../../assets/images/key-factors-in-business-lending-security-small.webp";
import typeOfSecurity from "../../assets/images/business-lending-types-of-security-for-securing-finance-small.webp";
import understandingRepaymentStructuresandLoanTerms from "../../assets/images/mastering-commercial-lending-repayment-structures-loan-terms-small.webp";
import strategiesforBuildingResilienceandThrivingAmidstChallenges from "../../assets/images/business-lending-loan-readiness-assessment-needs-analysis-2-small.webp";
import readinessAssessmentandNeedsAnalysisAwait from "../../assets/images/business-lending-loan-readiness-assessment-needs-analysis-small.webp";
import ensuringaSmoothApplicationProcessforYourBusinessFinance from "../../assets/images/checklist-smooth-application-process-for-business-finance-small.webp";
import comprehensiveOverviewofBusiness from "../../assets/images/overview-of-business-lending-in-a-changing-landscape-small.webp";
import assessingFinancialHealthandMakingInformedDecisions from "../../assets/images/understanding-ratios-in-commercial-lending-and-their-significance-small.webp";
import keyFactorsforStructuringBusinessFinance from "../../assets/images/business-finance-structuring-factors-for-informed-advice-small.webp";
import variableRatevsFixedRateLoansandTheirProsandCons from "../../assets/images/business-lending-exploring-different-loan-types-variable-rate-vs-fixed-rate-small.webp";
import exploringEffectiveExitStrategiesforBorrowers from "../../assets/images/mastering-commercial-lending-repayment-structures-loan-terms-small.webp";
import aPathtoFinancingWithoutTraditionalCollateral from "../../assets/images/unlock-business-growth-with-cash-flow-lending-small.webp";
import protectingBorrowersandLenders from "../../assets/images/business-lending-safeguarding-borrowers-and-lenders-in-financial-transactions-small.webp";
import componentsStructuresandInfluencingFactors from "../../assets/images/interest-rates-in-commercial-finance-small.webp";
import typesandImplicationsforBorrowersandLenders from "../../assets/images/business-lending-safeguarding-borrowers-and-lenders-in-financial-transactions2-small .webp";
import pexelsnilov from "../../assets/images/benefits-of-a-business-loan-small.webp";
import pexels from "../../assets/images/what-is-asset-finance-small.webp";
import understandingServiceabilityandKeyMeasuresforBusinessBorrowers from "../../assets/images/serviceability-and-key-measures-for-business-borrowers-small.webp";
import unlockingGrowthEquipmentasCollateralforFinancing from "../../assets/images/business-lending-exploring-different-loan-types-variable-rate-vs-fixed-rate-small.webp";
import fixedToVariable from "../../assets/images/fixed-interest-rate-to-variable-small.webp";
import offsetAccounts from "../../assets/images/offset-accounts-and-redraw-facilities-small.webp";
import firstHomeBuyers from "../../assets/images/first-home-buyers-family-pledge-guarantee-small.webp";
import lendersMortgageInsurance from "../../assets/images/lenders-mortgage-insurance-small.webp";
import variableRateLoans from "../../assets/images/variable-rate-loans-small.webp";
import splitLoans from "../../assets/images/split-loans-small.webp";
import interestOnlyLoans from "../../assets/images/interest-only-loans-and-repayment-types-small.webp";
import fixedRateHomeLoans from "../../assets/images/fixed-rate-home-loans-small.webp";
import creditCards from "../../assets/images/credit-card-small.webp";
import debtConsolidation from "../../assets/images/debt-consolidation-small.webp";
import howMuchDoesItCostToBuyProperty from "../../assets/images/how-much-does-it-really-cost-to-buy-property-small.webp";
import selfEmployedHomeTips from "../../assets/images/self-employed-home-loan-small.webp";
import depositBond from "../../assets/images/downsizers-deposit-bond-small.webp";
import depositBondCanHelp from "../../assets/images/first-home-buyers-deposit-bond-small.webp";
import tenCommon from "../../assets/images/deposit-bond-questions-small.webp";
import guide from "../../assets/images/beginners-guide-to-deposit-bonds-small.webp";
import buildWealth from "../../assets/images/property-investment-guide-small.webp";
import loanEssentials from "../../assets/images/Home-Loan-Essentials-small.webp";
import buyerEssentials from "../../assets/images/Home-Buyer-Essentials-small.webp";
import inOut from "../../assets/images/fixed-rate-loans-guide-small.webp";
import depositTips from "../../assets/images/home-deposit-saving-tips-small.webp";
import proCons from "../../assets/images/debt-consolidation-refinancing-small.webp";
import credit101 from "../../assets/images/bad-credit-rating-small.webp";
import crisis from "../../assets/images/covid-pandemic-financing-small.webp";
import longTerm from "../../assets/images/fixed-rate-loans-mortgage-small.webp";
import { useTranslation } from "react-i18next";

export const usePosts = () => {
  const { t } = useTranslation();

  const posts = [
    {
      id: 1,
      image: transformyourretirementwithhomeequityreleasesmaller,
      category: t("Retirees Equity Release"),
      relatedCategory: "retirees-equity-release",
      title: t("Transform Your Retirement with Home Equity Release"),
      slug: "transform-your-retirement-with-home-equity-release/",
      author: "Matthew Clark",
    },
    {
      id: 2,
      image: demystifyingBusinessFinanceJargon,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Demystifying Business Finance Jargon"),
      slug: "demystifying-business-finance-jargon/",
      author: "Matthew Clark",
    },
    {
      id: 3,
      image: comprehensiveLoanDocumentationChecklist,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Comprehensive Loan Application Checklist"),
      slug: "comprehensive-loan-documentation-checklist/",
      author: "Matthew Clark",
    },
    {
      id: 4,
      image: empoweringYourBusinessGrowth,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Empowering Your Business Growth"),
      slug: "empowering-your-business-growth/",
      author: "Matthew Clark",
    },
    {
      id: 5,
      image: gettingtheBasisofAdviceRight,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Getting the Basis of Advice Right"),
      slug: "getting-the-basis-of-advice-right/",
      author: "Matthew Clark",
    },
    {
      id: 6,
      image: exploringTheLenders,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Exploring The Lenders"),
      slug: "exploring-the-lenders/",
      author: "Matthew Clark",
    },
    {
      id: 7,
      image: assessingBorrowingCapacity,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Assessing Borrowing Capacity"),
      slug: "assessing-borrowing-capacity/",
      author: "Matthew Clark",
    },
    {
      id: 8,
      image: navigatingUncertainTimes,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Navigating Uncertain Times"),
      slug: "navigating-uncertain-times/",
      author: "Matthew Clark",
    },
    {
      id: 9,
      image: understandingRatiosinCommercialLending,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Understanding Ratios in Commercial Lending"),
      slug: "understanding-ratios-in-commercial-lending/",
      author: "Matthew Clark",
    },
    {
      id: 10,
      image: debtPaymentinFull,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Debt Payment in Full"),
      slug: "debt-payment-in-full/",
      author: "Matthew Clark",
    },
    {
      id: 11,
      image: exploringDifferentLoanTypes,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Exploring Different Loan Types"),
      slug: "exploring-different-loan-types/",
      author: "Matthew Clark",
    },
    {
      id: 12,
      image: understandingInterestRatesinCommercialFinance,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Understanding Interest Rates In Commercial Finance"),
      slug: "understanding-interest-rates-in-commercial-finance/",
      author: "Matthew Clark",
    },
    {
      id: 13,
      image: masteringCommercialLending,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Mastering Commercial Lending"),
      slug: "mastering-commercial-lending/",
      author: "Matthew Clark",
    },
    {
      id: 14,
      image: theImportanceofGuranteeandIndemnitties,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("The Importance of Guarantees and Indemnities"),
      slug: "the-importance-of-guarantees-and-indemnities/",
      author: "Matthew Clark",
    },
    {
      id: 15,
      image: unlockingBusinessGrowth,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Unlocking Business Growth"),
      slug: "unlocking-business-growth/",
      author: "Matthew Clark",
    },
    {
      id: 16,
      image: unlockingGrowth,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Unlocking Growth"),
      slug: "unlocking-growth/",
      author: "Matthew Clark",
    },
    {
      id: 17,
      image: understandingPropertySecurity,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Understanding Property Security"),
      slug: "understanding-property-security/",
      author: "Matthew Clark",
    },
    {
      id: 18,
      image: businessLoanReadinessAssessment,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t(
        "Business Loan Readiness Assessment: Unlocking Your Business’s Potential Through Comprehensive Discovery and Needs Analysis"
      ),
      slug: "business-loan-readiness-assessment-unlocking-your-businesss-potential-through-comprehensive-discovery-and-needs-analysis/",
      author: "Matthew Clark",
    },
    {
      id: 19,
      image: businessLendingUnderstanding,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t(
        "Business Lending – Understanding Serviceability and Covenant Ratios"
      ),
      slug: "business-lending-understanding-serviceability-and-covenant-ratios/",
      author: "Matthew Clark",
    },
    {
      id: 20,
      image: understandingLoanRepayment,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t(
        "Understanding Loan Repayment Structures and Interest Rates in Business Lending"
      ),
      slug: "understanding-loan-repayment-structures-and-interest-rates-in-business-lending-2/",
      author: "Matthew Clark",
    },
    {
      id: 21,
      image: guideToRatios,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t(
        "A Guide to Ratios and Financial Analysis to Understanding Business Lending Security Types"
      ),
      slug: "a-guide-to-ratios-and-financial-analysis-to-understanding-business-lending-security-types/",
      author: "Matthew Clark",
    },
    {
      id: 22,
      image: keyFactorsInLending,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Key Factors in Business Lending Security"),
      slug: "key-factors-in-business-lending-security/",
      author: "Matthew Clark",
    },
    {
      id: 23,
      image: typeOfSecurity,
      category: t("New Blogs"),
      relatedCategory: "new-blogs",
      title: t("Business Lending: Types of Security for Securing Finance"),
      slug: "business-lending-types-of-security-for-securing-finance/",
      author: "Matthew Clark",
    },
    {
      id: 24,
      image: understandingRepaymentStructuresandLoanTerms,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Mastering Commercial Lending: Repayment Structures & Loan Terms"
      ),
      slug: "mastering-commercial-lending-repayment-structures-loan-terms/",
      author: "Matthew Clark",
    },
    {
      id: 25,
      image: strategiesforBuildingResilienceandThrivingAmidstChallenges,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Business Lending: Loan Readiness Assessment & Needs Analysis"),
      slug: "business-lending-loan-readiness-assessment-needs-analysis-2/",
      author: "Matthew Clark",
    },
    {
      id: 26,
      image: readinessAssessmentandNeedsAnalysisAwait,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Business Lending: Loan Readiness Assessment & Needs Analysis"),
      slug: "business-lending-loan-readiness-assessment-needs-analysis/",
      author: "Matthew Clark",
    },
    {
      id: 27,
      image: ensuringaSmoothApplicationProcessforYourBusinessFinance,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Checklist: Smooth Application Process for Business Finance"),
      slug: "checklist-smooth-application-process-for-business-finance/",
      author: "Matthew Clark",
    },
    {
      id: 28,
      image: comprehensiveOverviewofBusiness,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Overview of Business Lending in a Changing Landscape"),
      slug: "overview-of-business-lending-in-a-changing-landscape/",
      author: "Matthew Clark",
    },
    {
      id: 29,
      image: assessingFinancialHealthandMakingInformedDecisions,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Understanding Ratios in Commercial Lending and Their Significance"
      ),
      slug: "understanding-ratios-in-commercial-lending-and-their-significance/",
      author: "Matthew Clark",
    },
    {
      id: 30,
      image: keyFactorsforStructuringBusinessFinance,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Business Finance Structuring: Factors for Informed Advice"),
      slug: "business-finance-structuring-factors-for-informed-advice/",
      author: "Matthew Clark",
    },
    {
      id: 31,
      image: variableRatevsFixedRateLoansandTheirProsandCons,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Business Lending: Exploring Different Loan Types: Variable Rate vs. Fixed Rate"
      ),
      slug: "business-lending-exploring-different-loan-types-variable-rate-vs-fixed-rate/",
      author: "Matthew Clark",
    },
    {
      id: 32,
      image: exploringEffectiveExitStrategiesforBorrowers,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Mastering Commercial Lending: Repayment Structures & Loan Terms"
      ),
      slug: "mastering-commercial-lending-repayment-structures-loan-terms-2/",
      author: "Matthew Clark",
    },
    {
      id: 33,
      image: understandingServiceabilityandKeyMeasuresforBusinessBorrowers,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Serviceability and Key Measures for Business Borrowers"),
      slug: "serviceability-and-key-measures-for-business-borrowers/",
      author: "Matthew Clark",
    },
    {
      id: 34,
      image: componentsStructuresandInfluencingFactors,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Interest Rates in Commercial Finance"),
      slug: "interest-rates-in-commercial-finance/",
      author: "Matthew Clark",
    },
    {
      id: 35,
      image: protectingBorrowersandLenders,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Business Lending: Safeguarding Borrowers and Lenders in Financial Transactions"
      ),
      slug: "business-lending-safeguarding-borrowers-and-lenders-in-financial-transactions/",
      author: "Matthew Clark",
    },
    {
      id: 36,
      image: aPathtoFinancingWithoutTraditionalCollateral,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t("Unlock Business Growth with Cash Flow Lending"),
      slug: "unlock-business-growth-with-cash-flow-lending/",
      author: "Matthew Clark",
    },
    {
      id: 37,
      image: unlockingGrowthEquipmentasCollateralforFinancing,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Business Lending: Exploring Different Loan Types: Variable Rate vs. Fixed Rate"
      ),
      slug: "business-lending-exploring-different-loan-types-variable-rate-vs-fixed-rate-2/",
      author: "Matthew Clark"
    },
    {
      id: 38,
      image: typesandImplicationsforBorrowersandLenders,
      category: t("E-Book"),
      relatedCategory: "e-book",
      title: t(
        "Business Lending: Safeguarding Borrowers and Lenders in Financial Transactions"
      ),
      slug: "business-lending-safeguarding-borrowers-and-lenders-in-financial-transactions-2/",
      author: "Matthew Clark",
    },
    {
      id: 39,
      image: pexelsnilov,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Benefits of a Business Loan"),
      slug: "benefits-of-a-business-loan/",
      author: "Matthew Clark",
    },
    {
      id: 40,
      image: pexels,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("What is Asset Finance? : Everything You Need to Know"),
      slug: "what-is-asset-finance/",
      author: "Matthew Clark",
    },
    {
      id: 41,
      image: fixedToVariable,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t(
        "From Fixed to Variable: 10 options to Navigate the Changing Interest Rate Landscape"
      ),
      slug: "fixed-interest-rate-to-variable/",
      author: "Matthew Clark",
    },
    {
      id: 42,
      image: offsetAccounts,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Offset accounts & redraw facilities"),
      slug: "offset-accounts-and-redraw-facilities/",
      author: "Matthew Clark",
    },
    {
      id: 43,
      image: firstHomeBuyers,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("First home buyers family pledge guarantee"),
      slug: "first-home-buyers-family-pledge-guarantee/",
      author: "Matthew Clark",
    },
    {
      id: 44,
      image: lendersMortgageInsurance,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Lenders mortgage insurance"),
      slug: "lenders-mortgage-insurance/",
      author: "Matthew Clark",
    },
    {
      id: 45,
      image: variableRateLoans,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Variable rate loans"),
      slug: "variable-rate-loans/",
      author: "Matthew Clark",
    },
    {
      id: 46,
      image: splitLoans,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Split loans"),
      slug: "split-loans/",
      author: "Matthew Clark",
    },
    {
      id: 47,
      image: interestOnlyLoans,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Interest only loans & repayment types"),
      slug: "interest-only-loans-and-repayment-types/",
      author: "Matthew Clark",
    },
    {
      id: 48,
      image: fixedRateHomeLoans,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Fixed rate home loans"),
      slug: "fixed-rate-home-loans/",
      author: "Matthew Clark",
    },
    {
      id: 49,
      image: creditCards,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Credit cards"),
      slug: "credit-cards/",
      author: "Matthew Clark",
    },
    {
      id: 50,
      image: debtConsolidation,
      category: t("Fact Sheets"),
      relatedCategory: "fact-sheets",
      title: t("Debt consolidation"),
      slug: "debt-consolidation/",
      author: "Matthew Clark",
    },
    {
      id: 51,
      image: howMuchDoesItCostToBuyProperty,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("How Much Does it Really Cost to Buy Property?"),
      slug: "how-much-does-it-really-cost-to-buy-property/",
      author: "Matthew Clark",
    },
    {
      id: 52,
      image: selfEmployedHomeTips,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Self-Employed Home Loan Tips"),
      slug: "self-employed-home-loan/",
      author: "Matthew Clark",
    },
    {
      id: 53,
      image: depositBond,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("How a Deposit Bond Can Help Downsizers"),
      slug: "downsizers-deposit-bond/",
      author: "Matthew Clark",
    },
    {
      id: 54,
      image: depositBondCanHelp,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("How a Deposit Bond Can Help First Home Buyers"),
      slug: "first-home-buyers-deposit-bond/",
      author: "Matthew Clark",
    },
    {
      id: 55,
      image: tenCommon,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("10 Most Common Deposit Bonds Questions Answered"),
      slug: "deposit-bond-questions/",
      author: "Matthew Clark",
    },
    {
      id: 56,
      image: guide,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("A Beginner’s Guide to Deposit Bonds"),
      slug: "beginners-guide-to-deposit-bonds/",
      author: "Matthew Clark",
    },
    {
      id: 57,
      image: buildWealth,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Property Investment Guide – Build Wealth Through Property"),
      slug: "property-investment-guide/",
      author: "Matthew Clark",
    },
    {
      id: 58,
      image: loanEssentials,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Home Loan Essentials – Why Choose a Mortgage Broker?"),
      slug: "home-loan-essentials/",
      author: "Matthew Clark",
    },
    {
      id: 59,
      image: buyerEssentials,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t(
        "Home Buyer Essentials – 5 Simple Steps to Understand the Home Buying Process"
      ),
      slug: "home-buyer-essentials/",
      author: "Matthew Clark",
    },
    {
      id: 60,
      image: inOut,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Fixed Rate Loans Guide: Know the Ins and Outs"),
      slug: "fixed-rate-loans-guide/",
      author: "Matthew Clark",
    },
    {
      id: 61,
      image: depositTips,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Home Deposit Tips on How to Save Better"),
      slug: "home-deposit-saving-tips/",
      author: "Matthew Clark",
    },
    {
      id: 62,
      image: proCons,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Debt Consolidation Refinancing Pros & Cons of Considering It"),
      slug: "debt-consolidation-refinancing/",
      author: "Matthew Clark",
    },
    {
      id: 63,
      image: credit101,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t(
        "Credit Score 101: Get Credit Score, Get Your Credit Fixed, Then Have a Home Loan"
      ),
      slug: "bad-credit-rating/",
      author: "Matthew Clark",
    },
    {
      id: 64,
      image: howMuchDoesItCostToBuyProperty,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t(
        "First Time Home Buyer Tips: 3 Things You Need to Know for Your First Home Purchase!"
      ),
      slug: "first-time-home-buyer-tips/",
      author: "Matthew Clark",
    },
    {
      id: 65,
      image: crisis,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t(
        "Crisis Financing Tips – Financing Options During Pandemic Crisis"
      ),
      slug: "covid-pandemic-financing/",
      author: "Matthew Clark",
    },
    {
      id: 66,
      image: longTerm,
      category: t("Insights"),
      relatedCategory: "insights",
      title: t("Fixed Home Loan Rates: Is it Good for Long Term?"),
      slug: "fixed-rate-loans-mortgage/",
      author: "Matthew Clark",
    },
  ];

  return posts || [];
};
